import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button } from 'semantic-ui-react';
import { FiCalendar, FiList } from 'react-icons/fi';

import { AppState } from 'services/types';
import ButtonIconWrapper from 'components/ButtonIconWrapper';
import { setPickScheduleLayout as setPickScheduleLayoutAction } from 'services/ui/actions';
import { selectPickScheduleLayout } from 'services/ui/selectors';

interface ConnectedProps {
    pickScheduleLayout: ReturnType<typeof selectPickScheduleLayout>;
}

interface DispatchProps {
    setPickScheduleLayout: typeof setPickScheduleLayoutAction;
}

export type Props = ConnectedProps & DispatchProps;

export class PickScheduleChooseLayoutButtonGroupComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | null {
        const { pickScheduleLayout, setPickScheduleLayout } = this.props;

        return (
            <Button.Group
                secondary
                style={{
                    marginRight: 0,
                    marginLeft: 8
                }}
            >
                <Button
                    icon
                    basic={pickScheduleLayout !== 'timeline'}
                    onClick={(): void => {
                        setPickScheduleLayout('timeline');
                    }}
                >
                    <ButtonIconWrapper noAdjacentText>
                        <FiCalendar
                            style={{
                                fontSize: 20
                            }}
                        />
                    </ButtonIconWrapper>
                </Button>
                <Button
                    icon
                    basic={pickScheduleLayout !== 'table'}
                    onClick={(): void => {
                        setPickScheduleLayout('table');
                    }}
                >
                    <ButtonIconWrapper noAdjacentText>
                        <FiList
                            style={{
                                fontSize: 20
                            }}
                        />
                    </ButtonIconWrapper>
                </Button>
            </Button.Group>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    pickScheduleLayout: selectPickScheduleLayout
});

export default connect(mapStateToProps, {
    setPickScheduleLayout: setPickScheduleLayoutAction
})(PickScheduleChooseLayoutButtonGroupComponent);
